import type { ReactElement, ReactNode } from 'react';

type LoadingStatusProps = {
  readonly children: ReactNode;
  readonly className?: string;
};

export const LoadingStatus = ({
  children,
  className = 'py-8',
}: LoadingStatusProps): ReactElement => (
  <p role="status" className={`text-muted text-center text-sm ${className}`}>
    {children}
  </p>
);
